import styled from "@emotion/styled";
import { Grid, Card} from "@mui/material";

import { useFormikContext } from "formik";

import { useFormData } from "../../../contexts/FormData";

import { formatGenericDate, formatGenericTime, formatCurrency } from "../../../utils/util";

import useIsMobile from "../../../hooks/useIsMobile";

const SummaryText = styled.span`
  @media ${props => props.theme.breaks.down('md')} {
    font-size: 1.2rem;
  }
`;


const SummaryLine = ({title, info}) => {
  const { isMobile} = useIsMobile();
  return (
    <Grid container spacing={isMobile ? 1 : 4} sx={{my: "1rem"}}>
      { !isMobile ? <Grid size={{xs: 0, md: 6}}>
      </Grid> : null }
      <Grid size={{xs: 6, md: 3}}><SummaryText>{title}</SummaryText></Grid>
      <Grid size={{xs: 6, md: 3}}><SummaryText>{info}</SummaryText></Grid>
    </ Grid>
  )
};


const Summary = () => {
  const { isMobile } = useIsMobile();
  const { values } = useFormikContext() || {};
  const { appointment_type, appointment_date, start_time, clients, services } = values

  let totalDuration = services?.reduce((total, service) => total + (+service.duration_in_minutes || 0), 0);

  let totalPrice = services?.reduce((total, service) => total + (+service.service_price || 0), 0);

  const { formValues } = useFormData() || {};

  const { customer_name, stylist_name } = formValues

  return (
    <Grid size={{xs: 12}}>
      <Card variant="outlined" sx={{backgroundColor: "#f9f9f9", padding: isMobile ? 1 : 0}}>
        <SummaryLine title="Appointment Type" info={appointment_type} />
        <SummaryLine title="Appointment Date" info={formatGenericDate(appointment_date)} />
        <SummaryLine title="Appointment Time" info={formatGenericTime(start_time)} />
        <SummaryLine title="End Date & Time" info={`${formatGenericDate(appointment_date)} ${formatGenericTime(start_time)}`} />
        <SummaryLine title="Customer Name" info={customer_name} />
        <SummaryLine title="Stylist" info={stylist_name} />
        <SummaryLine title="No. of Clients" info={clients?.length} />
        <SummaryLine title="No. of Services" info={services?.length} />
        <SummaryLine title="Total Duration" info={totalDuration} />
        <SummaryLine title="Total Price" info={formatCurrency(totalPrice)} />
      </Card>
    </Grid>
  )
};

export default Summary;